import React from "react";
import { Star } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, action, testId = "page-header" }) => (
  <div className="pmm-cinematic relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 p-6 shadow-2xl shadow-blue-900/25 sm:p-8" data-testid={testId}>
    <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-orange-500/25 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-20 -left-16 h-56 w-56 rounded-full bg-yellow-400/15 blur-3xl" />
    <div className="relative flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-yellow-400">
            <Star className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" />
            {eyebrow}
          </div>
        )}
        <h1 className="mt-1 font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1.5 font-semibold text-blue-200">{subtitle}</p>}
        <div className="mt-3 h-1 w-20 rounded-full bg-gradient-to-r from-yellow-400 to-transparent" />
      </div>
      {action && <div className="relative">{action}</div>}
    </div>
  </div>
);

export default PageHeader;
